/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';

export type DtmKadDocsDestroyRequest = {} | null | undefined;
export type DtmKadDocsDestroyResponse = any;

export type DtmKadDocsDestroyQuery = {
  /**
   * ```yaml
   * in: path
   * name: id
   * schema:
   *   type: integer
   * description: A unique integer value identifying this doc.
   * required: true
   * ```
   */
  id?: number;
};

/**
 * DELETE /dmx-server/dtm_kad_docs/{id}/
 *
 * ```yaml
 * operationId: dtm_kad_docs_destroy
 * tags:
 *   - dtm_kad_docs
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '204':
 *     description: No response body
 * ```
 */
export const dtmKadDocsDestroyOperation = ({ id, ...rest }: DtmKadDocsDestroyQuery) =>
  ({
    method: 'DELETE',
    path: `/dmx-server/dtm_kad_docs/${id}/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'DELETE';
    path: string & { _templateUrl: '/dmx-server/dtm_kad_docs/{id}/' };
  };

/**
 * DELETE /dmx-server/dtm_kad_docs/{id}/
 *
 * ```yaml
 * operationId: dtm_kad_docs_destroy
 * tags:
 *   - dtm_kad_docs
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '204':
 *     description: No response body
 * ```
 */
export const dtmKadDocsDestroy = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query: DtmKadDocsDestroyQuery;
  request?: {} | null;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<any>> => {
  const operation = dtmKadDocsDestroyOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'DELETE',
    request,
    onUploadProgress,
    cancelToken,
  );
};
